
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.236","height":"13.128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 43"}},[_c('g',{attrs:{"data-name":"グループ 41"}},[_c('path',{attrs:{"data-name":"パス 135","d":"M1.517 10.525l2.02.752V6.043l-2.02-.753z","fill":"rgba(0,0,0,0)"}}),_c('path',{attrs:{"data-name":"パス 136","d":"M5.058 11.277l2.018-.751v-5.2l-.017-.03-2 .745z","fill":"rgba(0,0,0,0)"}}),_c('path',{attrs:{"data-name":"パス 137","d":"M8.1 7.071c-.414-.7-.75-1.261-1.022-1.743v5.2l-2.018.751V6.045l2-.745a11.306 11.306 0 01-.681-1.365l-2.08.775-3.273-1.219a.759.759 0 00-1.023.711v6.853a.758.758 0 00.494.711l3.539 1.318h.011a.763.763 0 00.1.028l.024.006a.776.776 0 00.126.011.779.779 0 00.126-.011l.024-.006a.8.8 0 00.1-.028h.011l3.273-1.219 3.274 1.219a.759.759 0 001.023-.711v-.956a.759.759 0 00-1.506-.131L8.59 10.53V7.894a1.179 1.179 0 01-.07-.1zm-4.56 4.206l-2.02-.752V5.291l2.02.752z","fill":"#12b6d4"}}),_c('path',{attrs:{"data-name":"パス 138","d":"M11.089 7.097l-.41.69c-.02.033-.043.064-.065.1v.787a.759.759 0 101.517 0V5.521a.75.75 0 00-.019-.16c-.278.481-.612 1.047-1.023 1.736z","fill":"#0ac"}}),_c('path',{attrs:{"data-name":"パス 139","d":"M7.074 5.289l-.017.006.017.03z","fill":"#fff"}})]),_c('g',{attrs:{"data-name":"グループ 42"}},[_c('path',{attrs:{"data-name":"パス 140","d":"M9.26.021a2.649 2.649 0 00-2.293 2.714c.04.91.641 1.835 2.291 4.615a.4.4 0 00.684 0c1.712-2.883 2.293-3.771 2.293-4.716A2.636 2.636 0 009.26.021zm.34 3.338a.755.755 0 11.755-.755.755.755 0 01-.754.755z","fill":"#12b6d4"}})])])])
          )
        }
      }
    